import { render, staticRenderFns } from "./PosterTemplate.vue?vue&type=template&id=ae316c1c&scoped=true"
import script from "./PosterTemplate.vue?vue&type=script&lang=js"
export * from "./PosterTemplate.vue?vue&type=script&lang=js"
import style0 from "./PosterTemplate.vue?vue&type=style&index=0&id=ae316c1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae316c1c",
  null
  
)

export default component.exports